module.exports = __webpack_public_path__ + "img/register-banner.c1a47706.png";